<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'予約施設：特別営業日' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button (click)="selectBack()">
      <mat-icon>arrow_back</mat-icon>
      <span>{{'戻る' | translate}}</span>
    </button>

    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'追加' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field" fxLayout="row" fxLayoutGap="20px">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
  <mat-form-field fxFlex="15%">
    <mat-select placeholder="{{'営業日種別' | translate}}" id="reservationSpecialDateType" (selectionChange)="applyFilterAttr($event)">
      <mat-option [value]= ""></mat-option>
      <mat-option *ngFor="let reservationSpecialDateType of reservationSpecialDateTypes" [value]="reservationSpecialDateType">
        {{ reservationSpecialDateType | typeOfReservationSpecialDate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> {{'No.' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacilitySpecial; let i = index"> {{ (i + 1) + (paginator.pageSize *
        paginator.pageIndex) }} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacilitySpecial">
        <button mat-button color="primary" (click)="openEditDialog(reservationFacilitySpecial)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox color="warn" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'営業日種別' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacilitySpecial"> {{
        reservationFacilitySpecial.reservation_special_date_type | typeOfReservationSpecialDate }} </td>
    </ng-container>

    <ng-container matColumnDef="start_date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'開始日' | translate}}
      </th>
      <td mat-cell *matCellDef="let reservationFacilitySpecial"> {{
        reservationFacilitySpecial.reservation_special_start_date.toDate() | date: 'yyyy/MM/dd' }} </td>
    </ng-container>

    <ng-container matColumnDef="end_date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'終了日' | translate}}
      </th>
      <td mat-cell *matCellDef="let reservationFacilitySpecial">
        <span *ngIf="reservationFacilitySpecial.reservation_special_end_date!==null">{{
          reservationFacilitySpecial.reservation_special_end_date.toDate() | date: 'yyyy/MM/dd' }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'更新日時' | translate}}
      </th>
      <td mat-cell *matCellDef="let reservationFacility"> {{ reservationFacility.updated.toDate() | date: 'yyyy/MM/dd
        HH:mm:ss' }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>